module.exports = __webpack_public_path__ + "img/FAQ_mentees.5ad576e3.png";